
import React from "react";
import "./MainLayout.scss";


import Header from "./layout/Header/Header";
import Footer from "./layout/Footer/Footer";
import { Outlet } from "react-router-dom";

const MainLayout = ({ children }) => {
  return (
    <div className="main-layout">
      <Header />

      <div className="content-area">
         <Outlet />
      </div>

      <Footer />
    </div>
  );
};

export default MainLayout;
